import { Dispatch, SetStateAction, createContext } from 'react'

export interface FormStepContextEntity {
  currentStep: string | undefined
  setCurrentStep: Dispatch<SetStateAction<string | undefined>>
}

// Lets components rendered outside the router (e.g. the progress bar) know which step is showing
const FormStepContext = createContext<FormStepContextEntity>({
  currentStep: undefined,
  setCurrentStep: () => undefined,
})

export default FormStepContext
